import useSessionPermissionsLoadState from "permissions/session/use-session-permissions-load-state";
import { NotAuthorized } from "_shared/_errors/_views/not-authorized";
import { getSessionPermissions } from "permissions/_stores/permissions-redux-slice";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLoaderData, useNavigate } from "react-router";
import { useSession } from "users/__session/session-context";
import ContactsTab from "users/networking/_views/contacts-tab";
import CoworkersTab from "users/networking/_views/coworkers-tab";
import GroupsTab from "users/networking/_views/groups-tab";
import { PageTab } from "users/networking/_views/network-page-tabs";
import PendingTab from "users/networking/_views/pending-tab";


export default function Network() {
  const routeParams = useLoaderData();
  const activeTab = routeParams?.pageTab ? (routeParams.pageTab as PageTab) : PageTab.Contacts;

  const navigate = useNavigate();
  const session = useSession();
  const sessionPermissions = useSelector(getSessionPermissions);
  const permissionsLoadState = useSessionPermissionsLoadState();


  // Handle URL changes
  useEffect(() => {
    if (!session.user?.legalEntityId) return;

    if (!routeParams.pageTab) {
      navigate(`/network/${PageTab.Contacts}`);
    }
  }, [navigate, routeParams, session.user?.legalEntityId]);

  if (!sessionPermissions) return permissionsLoadState;
  if (!sessionPermissions.includesAccessToNetwork) return <NotAuthorized />;

  switch (activeTab) {
    case PageTab.Contacts:
      return <ContactsTab />;
    case PageTab.Coworkers:
      return <CoworkersTab />;
    case PageTab.Pending:
      return <PendingTab />;
    case PageTab.Groups:
      return <GroupsTab />;
    default:
      return <ContactsTab />;
  }
}
